<template>
    <div class="search-fields search-fields--price-overview-fields">
        <div class="search-field search-dates">
            <input-field ref="travelDates" :name="translations.travel_dates" :readonly="true"
                icon-type="calendar" @focus="showSelector = 'calendar'; dateSelection = 'FROM_DATE'"
                :value="dateString"
                :error="validation.fromDate || validation.toDate"></input-field>

            <skov-range-picker v-if="showSelector == 'calendar'" :showDateInputs="false" @close="closeCalendar"
                :value="initRange" @input="selectDates"></skov-range-picker>
        </div>
        <div class="search-field search-field--travelers">
            <input-field :name="translations.number_of_travelers" :value="numberOfTravelers" :readonly="true"
                icon-type="travelers" @focus="showSelector = 'travelers'"
                :error="validation.adults || validation.children"></input-field>
            <modal :title="translations.number_of_travelers" v-if="showSelector == 'travelers'" @close="showSelector = null"
                :close-on-click="true" :is-open="openModal == 'travelers'">
                <img src="../../../../../assets/img/icons/icon-persons.svg" alt="" slot="icon">
                <ul class="modal-view-list modal-view-list--no-hover">
                    <li class="modal-view-list__item">
                        <span class="modal-view-list__item__text" v-text="translations.number_of_adults"></span>
                        <count-picker :max="4" :min="0" v-model="form.adults"></count-picker>
                    </li>
                    <li class="modal-view-list__item">
                        <span class="modal-view-list__item__text" v-text="translations.number_of_children"></span>
                        <count-picker :min="0" :max="4" v-model="form.childrenCount"></count-picker>
                    </li>
                    <li class="modal-view-list__item" v-for="(val, key) in form.children" :key="key">
                        <span class="modal-view-list__item__text"
                            v-text="translations.children_ages.replace(/{n}/, key + 1)"></span>
                        <count-picker v-model="form.children[key]" :min="0" :max="maxChildrenAge"></count-picker>
                    </li>
                </ul>
                <div slot="footer" class="modal-view__footer">
                    <button v-text="translations.ok_btn" class="btn btn--success" @click="showSelector = null"></button>
                </div>
            </modal>
        </div>
        <button class="btn btn-with-icon btn--positive search-fields__btn" @click="search" :disabled="validForm">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.95 19.95">
                <path
                    d="m19.55,17.53l-3.77-3.77c.93-1.42,1.37-3.19,1.37-5.18,0-2.55-.72-4.74-2.28-6.3-1.56-1.55-3.75-2.28-6.3-2.28S3.83.72,2.28,2.28C.72,3.83,0,6.02,0,8.58s.72,4.74,2.28,6.3c1.56,1.55,3.75,2.28,6.3,2.28,1.99,0,3.76-.44,5.18-1.37l3.77,3.77c.27.26.63.4,1,.4.37,0,.73-.15,1-.42.26-.26.42-.62.42-1,0-.37-.14-.74-.4-1Zm-6.69-4.67c-.88.87-2.25,1.44-4.28,1.44s-3.4-.56-4.28-1.44-1.44-2.25-1.44-4.28.56-3.4,1.44-4.28c.87-.88,2.25-1.44,4.28-1.44s3.4.56,4.28,1.44c.87.87,1.44,2.25,1.44,4.28s-.56,3.4-1.44,4.28Z"
                    style="fill:#fff; fill-rule:evenodd;" />
            </svg>
            <span v-text="translations.search"></span>
        </button>
    </div>
</template>

<script>
import InputField from './../../input-field.vue';
import Moment from 'moment';
import SkovRangePicker from './../../daterangepicker/skovrangepicker.vue';
import Modal from './../../modal.vue';
import Validate from 'validate.js';
import QueryString from 'query-string';
import CountPicker from './../../count-picker.vue';

export default {
    props: {
        setForm: { type: Object, default: null }
    },
    data() {
        return {
            translations: APP_CONFIG.TRANSLATION.PRICE_OVERVIEW_WIDGET,
            maxChildrenAge: APP_CONFIG.MAX_AGE_CHILDREN,
            showSelector: null,
            openModal: null,
            dateSelection: null,
            selectedDates: {},
            validation: {},
            form: {
                fromDate: Moment().set({ hour: 0, minute: 0, second: 0 }).add(1, 'month'),
                toDate: Moment().set({ hour: 0, minute: 0, second: 0 }).add(1, 'month').add(7, 'days'),
                adults: 2,
                childrenCount: 0,
                children: [],
                flexibleStartDays: 0,
                flexibleEndDays: 0
            }
        }
    },
    mounted() {
        if (this.setForm) {
            let form = Object.assign({}, this.form, this.setForm);
            if (typeof form.fromDate == 'string') {
                form.fromDate = Moment(form.fromDate, 'YYYY-MM-DD');
            }

            if (typeof form.toDate == 'string') {
                form.toDate = Moment(form.toDate, 'YYYY-MM-DD');
            }

            if (typeof form.adults === 'string') {
                form.adults = parseInt(form.adults);
            }

            if (typeof form.flexibleStartDays == 'string') {
                form.flexibleStartDays = parseInt(form.flexibleStartDays);
            }

            if (typeof form.flexibleEndDays == 'string') {
                form.flexibleEndDays = parseInt(form.flexibleEndDays);
            }

            form.childrenCount = form.children.length;
            this.form = form;
        }
    },
    watch: {
        showSelector() {
            setTimeout(() => {
                this.openModal = this.showSelector;
            }, 250);
        },
        'form.childrenCount'(newVal, oldVal) {
            let children = Object.assign([], this.form.children);
            let newChildrenList = [];

            for (let i = 0; i < newVal; i++) {
                newChildrenList.push((children[i]) ? children[i] : 0);
            }

            this.form.children = newChildrenList;
        }
    },
    methods: {
        closeCalendar(evt) {
            if(!evt) {
                this.showSelector = null;
            } else if(!this.$refs.travelDates.$el.contains(evt.target)) {
                this.showSelector = null;
            }
        },
        search() {
            this.validation = {};
            let errors = this.validForm;
            if (errors) {
                this.validation = Object.assign({}, errors);
                return;
            }

            let query = Object.assign({}, this.form, {
                fromDate: this.form.fromDate.format('YYYY-MM-DD'),
                toDate: this.form.toDate.format('YYYY-MM-DD'),
                children: JSON.stringify(this.form.children)
            });

            delete query.childrenCount;
            window.location = '/prisoversigt?' + QueryString.stringify(query);
        },
        setDatesRange(dateObj) {
            if (dateObj.start) {
                this.form.fromDate = Moment(dateObj.start);
            } else if (this.selectedDates.fromDate) {
                this.form.fromDate = this.selectedDates.fromDate.clone();
            }

            if (dateObj.end) {
                this.form.toDate = Moment(dateObj.end);
            } else if (this.selectedDates.toDate) {
                this.form.toDate = this.selectedDates.toDate.clone();
            }
        },
        selectDates(dateObj) {
            this.form.fromDate = (dateObj.start) ? dateObj.start : null;
            this.form.toDate = (dateObj.end) ? dateObj.end : null;
            this.form.flexibleStartDays = dateObj.flexibleStartDays || 0;
            this.form.flexibleEndDays = dateObj.flexibleEndDays || 0;
            this.closeCalendar();
        },
        getInitialCalendarDate() {
            return this.dateSelection === 'FROM_DATE' ? this.form.fromDate : this.form.toDate;
        }
    },
    computed: {
        dateString() {
            let dateStr = '';

            if (this.form.fromDate) {
                dateStr += this.form.fromDate.format('DD. MMM');
                if (this.form.flexibleStartDays > 0) {
                    dateStr += ` (- ${this.form.flexibleStartDays})`;
                }
            }

            if (this.form.toDate) {
                dateStr += ` -  ${this.form.toDate.format('DD. MMM')}`;
                if (this.form.flexibleEndDays > 0) {
                    dateStr += ` (+ ${this.form.flexibleEndDays})`;
                }
            }

            return dateStr;
        },
        validForm() {
            let errors = Validate(this.form, {
                fromDate: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.from_date
                    }
                },
                toDate: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.to_date
                    }
                },
                adults: {
                    numericality: {
                        message: this.translations.ERRORS.adults
                    }
                },
                childrenCount: {
                    numericality: {
                        message: this.translations.ERRORS.children
                    }
                },
                flexibleStartDays: {
                    numericality: {
                        message: this.translations.ERRORS.flexible_days
                    }
                },
                flexibleEndDays: {
                    numericality: {
                        message: this.translations.ERRORS.flexible_days
                    }
                }
            }, {
                fullMessages: false
            });

            if (this.form.adults === 0 && this.form.childrenCount === 0) {
                if (!errors) {
                    errors = {};
                }

                errors['adults'] = this.translations.ERRORS.adults;
                errors['children'] = this.translations.ERRORS.children;
            }

            return (errors) ? errors : null;
        },
        numberOfTravelers() {
            let str = this.form.adults.toString() + ' ';
            str += (this.form.adults > 1 || this.form.adults === 0) ? this.translations.adults : this.translations.adult_single;
            str += ', ' + this.form.childrenCount + ' ';
            str += (this.form.childrenCount > 1 || this.form.childrenCount === 0) ? this.translations.children : this.translations.children_single;
            return str;
        },
        initRange() {
            return {
                start: Moment(this.form.fromDate).toDate(),
                end: Moment(this.form.toDate).toDate(),
                flexibleStartDays: this.form.flexibleStartDays,
                flexibleEndDays: this.form.flexibleEndDays
            }
        },
        startMonth() {
            return Moment(this.getInitialCalendarDate()).month();
        },
        startYear() {
            return Moment(this.getInitialCalendarDate()).year();
        },
    },
    components: {
        'input-field': InputField,
        SkovRangePicker,
        'modal': Modal,
        CountPicker
    }
}
</script>

